export type DispatchState =
  | 'awaiting_customer_approval'
  | 'dispatch_paused'
  | 'searching_for_rider'
  | 'rider_offered'
  | 'rider_accepted'
  | 'no_eligible_rider'
  | 'not_dispatchable';

export interface DispatchStatus {
  state: DispatchState;
  order_status: string;
  automatic_dispatch_enabled: boolean;
  attempt_status: string | null;
  offers_made: number;
  max_offers: number | null;
  search_ends_at: string | null;
  offer_expires_at: string | null;
  server_now: string;
}

export function mayDecideCustomerQuote(role: string | null | undefined, userId: string | null | undefined, customerId: string) {
  return role === 'customer' && userId === customerId;
}

export function dispatchStatusCopy(status: DispatchStatus) {
  switch (status.state) {
    case 'dispatch_paused':
      return { title: 'Dispatch is paused', body: 'Your quote is approved. Palihog will not offer it to a rider until automatic dispatch is enabled.' };
    case 'searching_for_rider':
      return { title: 'Searching for an eligible rider', body: 'Palihog is checking one rider at a time using current service, capacity, funding, location, and account eligibility.' };
    case 'rider_offered':
      return { title: 'Offer sent to one rider', body: 'The selected rider has a time-limited exclusive offer. This is not an accepted assignment yet.' };
    case 'rider_accepted':
      return { title: 'Rider accepted', body: 'The rider accepted the offer and the assignment is confirmed.' };
    case 'no_eligible_rider':
      return { title: 'No eligible rider is available', body: 'The bounded search ended without an eligible rider. Dispatch can review the blockers and retry safely.' };
    case 'awaiting_customer_approval':
      return { title: 'Awaiting customer approval', body: 'The exact quote must be approved by the customer before rider search can begin.' };
    default:
      return { title: 'Dispatch not available', body: 'This order is not currently eligible for automatic dispatch.' };
  }
}
